import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { communityGroups } from '@/mocks/community';

export default function HomeCommunity() {
  const groups = communityGroups.slice(0, 3);

  return (
    <section className="w-full bg-secondary-950 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.28em] text-accent-400">
                <span className="h-px w-6 bg-accent-500" />
                Community
              </span>
              <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-background-50 md:text-[32px]">
                找到坐标一致的群聊
              </h2>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-200/80">
                有人喜欢深夜慢慢梳理时间线，有人只想快速扫一眼新条目。这里的每一间群定位都不一样，先看描述再决定进哪间。
              </p>
            </div>
            <Link
              to="/community"
              className="inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-secondary-950 transition-colors hover:bg-accent-400"
            >
              查看全部入口
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {groups.map((group, index) => (
            <Reveal key={group.id} delay={index * 80}>
              <article className="flex h-full flex-col rounded-lg border border-secondary-800 bg-secondary-900/60 p-5 transition-colors hover:border-accent-500/60">
                <div className="flex items-center justify-between">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-800 text-accent-400">
                    <i className={`${group.icon} text-xl`} aria-hidden="true" />
                  </span>
                  <span
                    className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${
                      group.status === '快满'
                        ? 'bg-primary-500/20 text-primary-300'
                        : 'bg-secondary-800 text-background-200'
                    }`}
                  >
                    {group.status}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-background-50">{group.name}</h3>
                <p className="mt-2 flex-1 text-[13px] leading-relaxed text-background-300/80">{group.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-secondary-800 pt-3 text-xs text-background-300/70">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-3-line" aria-hidden="true" />
                    {group.members}
                  </span>
                  <span className="rounded bg-secondary-800 px-2 py-0.5">{group.platform}</span>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}